import React from 'react';
import { FadeIn, Section, CtaButton } from './Shared';
import { ShieldCheckIcon, LockIcon, TagIcon } from 'lucide-react';
export const PricingSection = () => {
  return <Section bg="cream" id="pricing" data-id="element-224">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100" data-id="element-225">
        <div className="grid md:grid-cols-2" data-id="element-226">
          <div className="bg-brand-teal/5 p-6 md:p-8 flex items-center justify-center" data-id="element-227">
            <FadeIn data-id="element-228">
              <img src="https://cdn.magicpatterns.com/uploads/jD6ooqAftkkWsDasxGYure/Higado_-_14_dias_.png" alt="Hígado Vital" className="rounded-xl shadow-lg w-full max-w-sm object-cover aspect-[4/5] transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-229" />
            </FadeIn>
          </div>

          <div className="p-6 md:p-8 flex flex-col justify-center text-center" data-id="element-230">
            <FadeIn delay={0.1} data-id="element-231">
              <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 font-bold text-xs uppercase tracking-widest px-3 py-1.5 rounded-full mx-auto mb-3" data-id="element-232">
                <TagIcon className="w-3.5 h-3.5" data-id="element-233" />
                <span data-id="element-234">79% de descuento</span>
              </div>

              <div className="bg-brand-yellow/15 border border-brand-yellow/30 rounded-xl px-4 py-2 mb-5 inline-block mx-auto" data-id="element-235">
                <p className="text-brand-charcoal font-semibold text-sm" data-id="element-236">
                  🔥 Precio especial de lanzamiento ·{' '}
                  <span className="text-brand-yellow" data-id="element-237">Tiempo limitado</span>
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-238">
              <p className="text-sm text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-239">
                Accede hoy por:
              </p>

              <div className="mb-1" data-id="element-240">
                <span className="text-lg text-gray-400 line-through" data-id="element-241">
                  $29.90 USD
                </span>
              </div>

              <div className="mb-2" data-id="element-242">
                <span className="text-5xl md:text-6xl font-bold text-brand-teal leading-none" data-id="element-243">
                  $6.39
                </span>
                <span className="text-xl font-semibold text-brand-teal ml-1" data-id="element-244">
                  USD
                </span>
              </div>

              <p className="text-gray-400 text-xs uppercase tracking-wide mb-5" data-id="element-245">
                / COP equivalente
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-246">
              <p className="text-base text-gray-500 mb-6 italic leading-snug" data-id="element-247">
                Menos de lo que has gastado en cosas que no funcionaron.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-248">
              <CtaButton className="w-full text-lg py-4" data-id="element-249">
                👉 COMENZAR AHORA
              </CtaButton>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-250">
              <div className="flex items-center justify-center gap-4 mt-5 text-xs text-gray-400" data-id="element-251">
                <div className="flex items-center gap-1.5" data-id="element-252">
                  <LockIcon className="w-3.5 h-3.5 text-green-500" data-id="element-253" />
                  <span data-id="element-254">Pago seguro</span>
                </div>
                <div className="w-px h-3 bg-gray-200" data-id="element-255"></div>
                <div className="flex items-center gap-1.5" data-id="element-256">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-green-500" data-id="element-257" />
                  <span data-id="element-258">Garantía 14 días</span>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </Section>;
};